import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G4_P3_S1_Title: {
    id: `guide04.page03.slide01.title`,
  },
  G4_P3_S1_Description: {
    id: `guide04.page03.slide01.description`,
  },
  G4_P3_S1_Tab1Title: {
    id: `guide04.page03.slide01.tab1Title`,
  },
  G4_P3_S1_Tab2Title: {
    id: `guide04.page03.slide01.tab2Title`,
  },
  G4_P3_S1_WMS_Label: {
    id: `guide04.page03.slide01.wms-label`,
  },
  G4_P3_S1_WMS_Text: {
    id: `guide04.page03.slide01.wms-text`,
  },
  G4_P3_S1_AmbiMic_Label: {
    id: `guide04.page03.slide01.ambisonic-mic-label`,
  },
  G4_P3_S1_AmbiMic_Text: {
    id: `guide04.page03.slide01.ambisonic-mic-text`,
  },
  G4_P3_S1_Monitoring_System_Label: {
    id: `guide04.page03.slide01.monitoring-system-label`,
  },
  G4_P3_S1_Monitoring_System_Text: {
    id: `guide04.page03.slide01.monitoring-system-text`,
  },
  G4_P3_S1_LavalierMicrophones_Label: {
    id: `guide04.page03.slide01.lavalier-microphones-label`,
  },
  G4_P3_S1_LavalierMicrophones_Text: {
    id: `guide04.page03.slide01.lavalier-microphones-text`,
  },
});
